import { Component, OnInit, Input, OnChanges, SimpleChanges, Optional, Inject, ViewChild, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { NameValue } from 'projects/sepidz-web-framework/src/lib/models/name-value';
import { BaseControlComponent } from '../base/base-control.component';
import { SelectorService } from '../base/selector.service';

@Component({
  selector: 'template-input',
  templateUrl: './template-input.component.html',
  styleUrls: ['./template-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateInputComponent extends BaseControlComponent<string>  {
  @Input() items: NameValue[];
  @Input() rows = 10;
  @Input() cols = 50;
  @Input() placeholder: string;
  @Input() hint: string;
  @Input() validationRules: { [key: string]: string };
  _textValue: string;
  @Output() textValueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input()
  set textValue(value: string) {
    this._textValue = value;
    if (this.name)
      this.setInputControlValue(this._textValue);
  }
  get textValue(): string {
    return this.replaceItemValues(this.f[this.name].value);
  }

  constructor(protected selectorService: SelectorService,protected cd: ChangeDetectorRef) {
    super(selectorService,cd);
  }

  private setInputControlValue(inputValue) {
    this.f[this.name].setValue(this.replaceItemNames(inputValue));
  }

  private replaceItemValues(value: string): string {
    this.items.forEach(t => {
       value = value.replace(this.wrap(t.Name), t.Value);
    });
    return value;
  }

  private replaceItemNames(value: string): string {
    if (!value) {
      return;
    }
    this.items.forEach(t => {
      value = value.replace(t.Value, this.wrap(t.Name));
    });
    return value;
  }

  addItem(name: string, input: HTMLTextAreaElement) {
    const text = this.wrap(name);

    const value = input.value;

    const start = input.selectionStart;
    const end = input.selectionEnd;

    input.value = `${value.slice(0, start)}${text}${value.slice(end)}`;

    input.selectionStart = input.selectionEnd = start + text.length;
    this.f[this.name].setValue(input.value);
    this.textValueChange.emit(this.textValue);
    input.focus();
  }

  wrap(text) {
    return `[${text}]`;
  }
  onChange(value: string) {
    if (this.textValue)
      this.textValueChange.emit(this.textValue);
  }
}
